
angular.module('bmsApp.marketing').controller('MarketingMainCtrl', ['$scope', 'CustomerGroupSvc', function ($scope, CustomerGroupSvc) {
		

		
		$scope.$on('customerGroupIndexUpdated', function(e, tableCount) {
			$scope.tableCount = tableCount;
		});
		
		$scope.$on('campaignIndexUpdated', function(e, tableCount) {
			$scope.tableCount = tableCount;
		});
		
		
	}]);
